import React from "react";
import { Route, Routes } from "react-router-dom";

import CoverageArea from "@/components/screens/CoverageArea";
import CoverageAreaFormPage from "@/components/screens/CoverageAreaFormPage";
import { COVERAGE_AREA_FORM_MESSAGES } from "@/messages/coverage-area/coverage-area-form.messages";
import { COVERAGE_AREA_MESSAGES } from "@/messages/coverage-area/coverage-area.messages";

const CoverageAreaPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<CoverageArea messages={COVERAGE_AREA_MESSAGES} />} />
      <Route
        path="/create/:lang"
        element={<CoverageAreaFormPage messages={COVERAGE_AREA_FORM_MESSAGES} />}
      />
      <Route
        path="/update/:coverageAreaId/:lang"
        element={<CoverageAreaFormPage messages={COVERAGE_AREA_FORM_MESSAGES} />}
      />
      <Route path="/" element={<CoverageArea messages={COVERAGE_AREA_MESSAGES} />} />
    </Routes>
  );
};

export default CoverageAreaPage;
